import React, { useRef, useState } from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import { Auth } from 'aws-amplify'
import UpdateMovie from '../../Services/Mutations/UpdateMovie'
import { GetCurrentDate, getCurrentTimeUnixTimestamp } from './formatTodayDate'
import TextAreaMovieAndOttNews from './TextAreaMovieAndOttNews'
import MovieAndOTTNewsTable from './MovieAndOttNewsTable'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'

const MovieAndOttNews = props => {
  const {
    inputData,
    sendinputdata,
    // editOttAndNewsPermission,
    DeleteOttAndNewsPermission,
    ApproveOttAndNewsPermission,
    movieData,
  } = props
  const [movieAndOttNews, setMovieAndOttNews] = useState('')
  const [movieAndOttNewste, setMovieAndOttNewste] = useState('')
  const [editIndex, setEditIndex] = useState(null)
  const inputReferencedescriptionEn = useRef(null)
  const inputReferencedescriptionTe = useRef(null)
  const [link, setLink] = useState('')
  // const [showAllItems, setShowAllItems] = useState(false)

  const tableHeaders = [
    'status',
    // 'moderatorHandle',
    'description_En',
    'description_Te',
  ]

  const loggedInUserEmail = Auth.user.attributes?.email || ''
  const loggedInUserHandle = loggedInUserEmail ? `@${loggedInUserEmail.split('@')[0]}` : ''

  const updateData = async updates => {
    const updatedData = { ...inputData, ...updates }
    // Remove the field '__typename' from each object in the 'movieAndOTTNewsUpdates' array
    const updatedMovieAndOTTNewsUpdates = updatedData.movieAndOTTNewsUpdates.map(item => {
      // Create a copy of the object without the field '__typename'
      const { __typename, ...updatedItem } = item
      return updatedItem
    })

    sendinputdata(updatedData)
    const input = {
      PK: movieData.PK,
      SK: movieData.SK,
      movieID: movieData.movieID,
      contentType: inputData.contentType,
      movieAndOTTNewsUpdates: updatedMovieAndOTTNewsUpdates,
    }
    const update = await UpdateMovie(input)
    if (update.statusCode === 'A001') {
      toast.success(update.statusMessage, ToastStyle)
    }
    // sendBooleanValueChangeDone('movieAndOTTNewsUpdates', true)
  }

  const sendOttToArray = () => {
    updateData({
      movieAndOTTNewsUpdates: [
        {
          status: 'draft',
          moderatorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
          description_En: movieAndOttNews,
          description_Te: movieAndOttNewste,
        },
        ...inputData.movieAndOTTNewsUpdates,
      ],
    })
    // sendBooleanValueChangeDone('movieAndOTTNewsUpdates', true)
    setMovieAndOttNews('')
    setMovieAndOttNewste('')
  }

  const deleteFunction = index => {
    updateData({
      movieAndOTTNewsUpdates: inputData.movieAndOTTNewsUpdates.filter((_, i) => i !== index),
    })
  }

  const approveFunction = index => {
    updateData({
      movieAndOTTNewsUpdates: inputData.movieAndOTTNewsUpdates.map((item, i) => {
        if (i === index && item.status === 'draft') {
          return {
            ...item,
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
            status: 'published',
            publishedDate: GetCurrentDate(),
            publishedTime: getCurrentTimeUnixTimestamp(),
          }
        }

        return item
      }),
    })
  }

  const editFunction = index => {
    const itemToEdit = inputData.movieAndOTTNewsUpdates[index]
    setEditIndex(index)

    setMovieAndOttNews(itemToEdit.description_En)
    setMovieAndOttNewste(itemToEdit.description_Te)
  }

  const saveEdit = () => {
    updateData({
      movieAndOTTNewsUpdates: inputData.movieAndOTTNewsUpdates.map((item, index) => {
        if (index === editIndex) {
          return {
            ...item,
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
            description_En: movieAndOttNews,
            description_Te: movieAndOttNewste,
          }
        }

        // if (index === 0 && editIndex === 0) {
        //   return {
        //     ...item,
        //     moderatorID: Auth.user.username,
        //     moderatorHandle: loggedInUserHandle,
        //     description_En: movieAndOttNews,
        //     description_Te: movieAndOttNewste,
        //   }
        // }

        return item
      }),
    })
    setEditIndex(null)
    setMovieAndOttNews('')
    setMovieAndOttNewste('')
  }

  // const handleButtonClick = description => {
  //   // eslint-disable-next-line no-alert
  //   const link = window.prompt('Enter the link:')
  //   if (link !== null) {
  //     const textarea =
  //       description === 'description_En'
  //         ? inputReferencedescriptionEn.current
  //         : inputReferencedescriptionTe.current

  //     if (
  //       textarea.selectionStart !== undefined &&
  //       textarea.selectionEnd !== undefined
  //     ) {
  //       const start = textarea.selectionStart
  //       const end = textarea.selectionEnd

  //       const selectedText =
  //         description === 'description_En'
  //           ? movieAndOttNews.substring(start, end)
  //           : movieAndOttNewste.substring(start, end)
  //       let updatedText = ''
  //       if (selectedText) {
  //         updatedText =
  //           description === 'description_En'
  //             ? `${movieAndOttNews.substring(
  //                 0,
  //                 start,
  //               )}${`<a href='${link}'>`}${selectedText}${'</a>'}${movieAndOttNews.substring(
  //                 end,
  //               )}`
  //             : `${movieAndOttNewste.substring(
  //                 0,
  //                 start,
  //               )}${`<a href='${link}'>`}${selectedText}${'</a>'}${movieAndOttNewste.substring(
  //                 end,
  //               )}`
  //       }

  //       // else {
  //       //   updatedText = `${
  //       //     description === 'description_En'
  //       //       ? movieAndOttNews
  //       //       : movieAndOttNewste
  //       //   } ${`<a href='${link}'>`}${'</a>'}`
  //       // }
  //       if (updatedText) {
  //         (description === 'description_En'
  //           ? setMovieAndOttNews
  //           : setMovieAndOttNewste)(updatedText)
  //       }
  //     }
  //   }
  // }

  const renderActions = (item, index) => {
    const actions = []
    if (item.status === 'draft' && ApproveOttAndNewsPermission) {
      actions.push(
        <span
          key='approve'
          className='cursor-pointer actionIconStylemovie'
          data-toggle='tooltip'
          title='Approve'
          onClick={() => approveFunction(index)}
        >
          <i className='fa fa-upload' />
        </span>,
      )
    }

    if (item.status === 'draft' || DeleteOttAndNewsPermission) {
      actions.push(
        <span
          key='delete'
          className='cursor-pointer actionIconStylemovie'
          data-toggle='tooltip'
          title='Delete'
          onClick={() => deleteFunction(index)}
        >
          <i className='fa fa-trash' />
        </span>,
      )
    }

    actions.push(
      <span
        key='edit'
        className='cursor-pointer actionIconStylemovie'
        data-toggle='tooltip'
        title='Edit'
        onClick={() => editFunction(index)}
      >
        <i className='fa fa-edit' />
      </span>,
    )

    return actions
  }

  return (
    <div style={{ marginTop: '10px', position: 'relative', zIndex: '1' }}>
      <Accordion allowZeroExpanded style={{ position: 'relative', zIndex: '1' }}>
        <AccordionItem>
          <AccordionItemButton>MovieAndOttNews</AccordionItemButton>
          <AccordionItemPanel>
            <div className='ottTableContainer'>
              <MovieAndOTTNewsTable
                inputData={inputData}
                tableHeaders={tableHeaders}
                editIndex={editIndex}
                renderActions={renderActions}
                movieAndOTTNewsUpdates={inputData.movieAndOTTNewsUpdates}
                // showAllItems={showAllItems}
              />
            </div>
            <TextAreaMovieAndOttNews
              inputReferencedescriptionEn={inputReferencedescriptionEn}
              inputReferencedescriptionTe={inputReferencedescriptionTe}
              movieAndOttNews={movieAndOttNews}
              movieAndOttNewste={movieAndOttNewste}
              setMovieAndOttNews={setMovieAndOttNews}
              setMovieAndOttNewste={setMovieAndOttNewste}
              // handleButtonClick={handleButtonClick}
              editIndex={editIndex}
              sendOttToArray={sendOttToArray}
              saveEdit={saveEdit}
              link={link}
              setLink={setLink}
            />
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

export default MovieAndOttNews
